import { type PropsWithChildren } from 'react';
import { HStack, VStack } from '@direct-frontend/components';
import { ProductFormSidebar, type ProductFormSidebarProps } from '../ProductFormSidebar';
import styles from './ProductFormLayout.module.css';

export const ProductFormLayout = ({ children, ...sidebarProps }: PropsWithChildren<ProductFormSidebarProps>) => (
    <HStack gap="8" alignItems="stretch" className={styles.layout}>
        <ProductFormSidebar {...sidebarProps} />
        <VStack className={styles.content} gap="8" data-testid="ProductForm.Content">
            {children}
        </VStack>
    </HStack>
);
